import React from 'react';
import './galaxyMemberRestoration.css';

export default function GalaxyMemberRestoration({ administration }) {
  const { authorized, busy, error, message, open, excluded, restore, toggle } = administration;
  return (
    <div className="galaxyMemberAdministration">
      {error && <p role="alert">{error}</p>}
      {message && <p role="status">{message}</p>}
      {authorized && <>
        <button type="button" onClick={toggle} disabled={busy} aria-expanded={open}>Removed members</button>
        {open && <div aria-label="Removed Galaxy members">
          <p>Restoration allows normal admission again. It does not restore membership or previous Galaxy roles.</p>
          {busy && <p role="status">Updating...</p>}
          {!busy && !error && excluded.length === 0 && <p>No removed members.</p>}
          {excluded.map((person) => <div key={person._id} className="galaxyRemovedMember">
            <span>{person.playerId}</span>
            <button type="button" disabled={busy} onClick={() => restore(person)} aria-label={`Allow ${person.playerId} to rejoin`}>Allow rejoining</button>
          </div>)}
        </div>}
      </>}
    </div>
  );
}
